<div
    class="flex-status-gauge"
    [ngClass]="state"
    role="meter"
    [attr.aria-label]="label"
    [attr.aria-valuemin]="configuration.minimum"
    [attr.aria-valuemax]="configuration.maximum"
    [attr.aria-valuenow]="state === 'unknown' ? null : validValue"
    [attr.aria-valuetext]="ariaValueText"
>
    <div class="gauge-chart" #chartTarget aria-hidden="true"></div>
    <div class="gauge-reading">
        <div class="gauge-value">{{ displayValue }}</div>
        <div class="gauge-state">{{ stateText }}</div>
    </div>
    <div class="gauge-label">{{ label }}</div>
</div>
